import styled from '@emotion/styled'
import { AiOutlineLeft, AiOutlinePlus } from 'react-icons/ai'
import { BiPencil } from 'react-icons/bi'
import { mobile, useScreen } from '../../../utils/responsive-helper'
import TitleHeader from '../../../components/app-layout/AppHeader/TitleHeader'
import Text from '../../../components/common/Text'
import * as paths from '../../../constant/path'
import { DARK_GRAY, ORANGE, WHITE } from '../../../constant/colors'
import { useHistory } from 'react-router'
import Modal from '../../../components/common/Modal'
import { useVisibility } from '../../../utils/custom-hook'
import AddressForm from '../AddressForm'
import {
  useCreateAddress,
  useEditAddress,
  useGetAdressList,
} from '../../../services/address/address-query'
import { AddressType, AddressValues } from '../../../services/address/address-typed'
import { useEffect, useState } from 'react'

const Layout = styled.div`
  padding: 8px 0;
  ${mobile} {
    margin-top: 64px;
    margin-bottom: 80px;
  }
`

const ShopAddressStyled = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 24px;
  ${mobile} {
    display: block;
    padding-top: 16px;
  }
`

const ShopAddressCard = styled.div`
  display: flex;
  justify-content: space-between;
  background: ${WHITE};
  padding: 16px;
  margin-bottom: 16px;
  border-radius: 4px;
`

const NameText = styled(Text)`
  display: flex;
  align-items: center;
`

const AddressText = styled(Text)`
  display: flex;
  align-items: center;
`

const ShopAddAddressCart = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${WHITE};
  border-radius: 4px;
  padding: 16px;
`

const PlusButton = styled(Text)`
  display: flex;
`

const AddressFormLayout = styled.div`
  max-width: 750px;
  padding: 16px;
`

const ShopCartAddresses = () => {
  const history = useHistory()
  const { isMobile } = useScreen()
  const [addAddressVisible, addAddressAction] = useVisibility()
  const [editAddressVisible, editAddressAction] = useVisibility()
  const { data } = useGetAdressList()
  const { mutate: createAddress } = useCreateAddress()
  const { mutate: editAddress } = useEditAddress()
  const [addressList, setAddressList] = useState<AddressType[]>([])
  const [addressSelected, setAddressSelected] = useState<AddressType>()

  useEffect(() => {
    if (data) {
      const defaultAddress = data.filter((addressFilter) => addressFilter.defaultAddress)
      const address = data.filter((addressFilter) => !addressFilter.defaultAddress)
      setAddressList([...defaultAddress, ...address])
    }
  }, [data])

  const handleNewAddressNavigation = () => {
    if (isMobile) {
      history.push(paths.shopCartNewAddress())
    } else {
      addAddressAction.show()
    }
  }

  const handleUpdateAddressNavigation = (e: any, address: AddressType) => {
    if (isMobile) {
      history.push(paths.shopCartAddressDetial({ routeParam: { addressId: address.id } }))
    } else {
      setAddressSelected(address)
      editAddressAction.show()
    }
    e.stopPropagation()
  }

  const handlePaymentNavigation = (addressId: number) => {
    history.push(paths.shopCartPayment({ queryParam: { addressId } }))
  }

  const handleAddress = (address: AddressType) => {
    const checkAddress = (text: string | number | undefined) => {
      return text !== null ? `${text} ` : ''
    }
    return `${checkAddress(address.street)}${checkAddress(address.subDistrict)}${checkAddress(
      address.district,
    )}${checkAddress(address.province)}${checkAddress(address.postcode)}`
  }

  return (
    <Layout>
      {isMobile && (
        <TitleHeader title="ที่อยู่จัดส่งสินค้า" icon={<AiOutlineLeft />} path={paths.shopCart()} />
      )}
      <ShopAddressStyled>
        {addressList?.map((address) => (
          <ShopAddressCard key={address?.id} onClick={() => handlePaymentNavigation(address.id)}>
            <div>
              <NameText size={16} color={DARK_GRAY}>
                {address.name || 'ไม่มีชื่อ'}
                {isMobile && address?.defaultAddress && (
                  <Text size={12} color={ORANGE} style={{ paddingLeft: 4 }}>
                    [ค่าเริ่มต้น]
                  </Text>
                )}
              </NameText>
              <AddressText color={DARK_GRAY}>
                {handleAddress(address)}
                {!isMobile && address?.defaultAddress && (
                  <Text size={12} color={ORANGE} style={{ paddingLeft: 4 }}>
                    [ค่าเริ่มต้น]
                  </Text>
                )}
              </AddressText>
            </div>
            <Text
              size={20}
              color={ORANGE}
              onClick={(e) => handleUpdateAddressNavigation(e, address)}
            >
              <BiPencil />
            </Text>
          </ShopAddressCard>
        ))}
        <ShopAddAddressCart onClick={handleNewAddressNavigation}>
          <Text color={DARK_GRAY}>เพิ่มที่อยู่ใหม่</Text>
          <PlusButton size={20} color={DARK_GRAY}>
            <AiOutlinePlus />
          </PlusButton>
        </ShopAddAddressCart>
      </ShopAddressStyled>
      <Modal
        visible={addAddressVisible}
        onCancel={addAddressAction.hide}
        style={{
          padding: 0,
        }}
        hideFooter
      >
        <AddressFormLayout>
          <Text size={24} color={DARK_GRAY} type="Bold" style={{ paddingBottom: 16 }}>
            เพิ่มที่อยู่ใหม่
          </Text>
          <AddressForm
            onSubmit={(form: AddressValues) => {
              createAddress(form, {
                onSettled: () => {
                  addAddressAction.hide()
                },
              })
            }}
          />
        </AddressFormLayout>
      </Modal>
      <Modal
        visible={editAddressVisible}
        onCancel={editAddressAction.hide}
        style={{
          padding: 0,
        }}
        hideFooter
      >
        <AddressFormLayout>
          <Text size={24} color={DARK_GRAY} type="Bold" style={{ paddingBottom: 16 }}>
            แก้ไขที่อยู่
          </Text>
          <AddressForm
            initialValues={addressSelected}
            onSubmit={(form: AddressValues) => {
              editAddress(form, {
                onSettled: () => {
                  editAddressAction.hide()
                },
              })
            }}
          />
        </AddressFormLayout>
      </Modal>
    </Layout>
  )
}

export default ShopCartAddresses
